import StripeElements from './stripe-elements'

export default StripeElements
